webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(50),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59e756cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-080c09d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5e5a1bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(52),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a13b60f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-340097e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dc8f093",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_price__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_contact__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_contact__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_home___default.a
  }, {
    path: '/price',
    name: 'price',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_price___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_contact___default.a
  }],
  scrollBehavior: function scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  }
}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(33)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(54),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'banner'
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'features',
  data: function data() {
    return {
      featureData: [{
        header: '智能调度',
        logo: 'coalesce',
        content: '用户可根据自身需求，配置接入的各 CDN 厂商，融合各家资源，按任意比例配置调度各厂商间的流量，统一管理操作。'
      }, {
        header: '超融合',
        logo: 'dispatch',
        content: '自动探测各接入 CDN 厂商的节点信息，统筹分析相互结合，使每个域名都能达到在不同地区不同运营商都有本地化节点覆盖。'
      }, {
        header: '自动容灾',
        logo: 'disaster',
        content: '实时监测各接入 CDN 厂商的节点服务情况，如某个节点有问题，则自动剔除并切换到其他厂商节点，保障业务的正常服务。'
      }, {
        header: '实时监控',
        logo: 'monitor',
        content: '监测数据实时上报，并且会通过邮件、短信、电话等多维度进行告警通知，帮助您在第一时间掌握域名的运行状况。'
      }]
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout-footer',
  data: function data() {
    return {
      icpHref: 'https://beian.miit.gov.cn/',
      icpText: '浙ICP备15031660号-4',
      domainList: {
        'www.zhidian-inc.cn': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-1'
        },
        'www.upcdn.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-2'
        },
        'www.aicdn.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-7'
        },
        'www.upaiyun.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-9'
        },
        'www.oncdp.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-4'
        },
        'www.aicdn5.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-18'
        },
        'www.cdnv1.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-20 '
        },
        'www.aicdn4.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-17'
        },
        'www.aicdn2.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-11'
        },
        'www.cdnv2.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-19'
        },
        'www.aicdn3.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-13'
        },
        'www.upai.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-12'
        },
        'localhost': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-4'
        }
      }
    };
  },
  mounted: function mounted() {
    var domain = window.location.hostname;
    if (domain) {
      this.icpHref = this.domainList[domain].icpHref;
      this.icpText = this.domainList[domain].icpText;
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'functions',
  data: function data() {
    return {
      functionData: [{
        logo: 'cdn',
        header: '支持多家 CDN 服务商',
        content: '支持配置市面上所有热门 CDN 服务厂商'
      }, {
        logo: 'rate',
        header: '支持按比例配置',
        content: '可按任意比例配置调度，在各 CDN 厂商间进行负载均衡'
      }, {
        logo: 'route',
        header: '自定义线路',
        content: '支持各运营商、省份、海外灵活结合配置'
      }, {
        logo: 'strategy',
        header: '调度精准',
        content: '支持 EDNS，根据客户端 IP 进行调度解析，有效的防劫持'
      }, {
        logo: 'safety',
        header: '稳定安全',
        content: '支持海量并发访问，有效防护 DNS 的恶意攻击，保证域名服务正常'
      }, {
        logo: 'api',
        header: 'API',
        content: '强大开放的 API，让您的配置更加方便快捷'
      }]
    };
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout-header',
  props: {
    headerBgc: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerStyle: function headerStyle() {
      return {
        background: this.headerBgc ? '#00a0ff' : 'none',
        position: this.headerBgc ? 'static' : 'absolute'
      };
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  props: {
    headerBgc: {
      type: Boolean,
      default: false
    }
  },
  components: { LayoutHeader: __WEBPACK_IMPORTED_MODULE_0__header___default.a, LayoutFooter: __WEBPACK_IMPORTED_MODULE_1__footer___default.a }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usage'
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'whatis'
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_features__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_features__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usage__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_usage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_functions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_whatis__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_whatis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_whatis__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  components: { Layout: __WEBPACK_IMPORTED_MODULE_0__components_layout___default.a, Banner: __WEBPACK_IMPORTED_MODULE_1__components_banner___default.a, Features: __WEBPACK_IMPORTED_MODULE_2__components_features___default.a, Functions: __WEBPACK_IMPORTED_MODULE_4__components_functions___default.a, Usage: __WEBPACK_IMPORTED_MODULE_3__components_usage___default.a, WhatIs: __WEBPACK_IMPORTED_MODULE_5__components_whatis___default.a }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_features__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_features___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_features__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usage__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_usage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_functions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_whatis__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_whatis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_whatis__);
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { Layout: __WEBPACK_IMPORTED_MODULE_0__components_layout___default.a, Banner: __WEBPACK_IMPORTED_MODULE_1__components_banner___default.a, Features: __WEBPACK_IMPORTED_MODULE_2__components_features___default.a, Functions: __WEBPACK_IMPORTED_MODULE_4__components_functions___default.a, Usage: __WEBPACK_IMPORTED_MODULE_3__components_usage___default.a, WhatIs: __WEBPACK_IMPORTED_MODULE_5__components_whatis___default.a }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'price',
  data: function data() {
    return {
      priceData: [{
        icon: 'free',
        title: '免费版',
        desc: ['小微企业、非盈利性的个人网站', '博客等'],
        feature: [{ type: '接入 CDN 服务商', support: true, content: '2 家' }, { type: '智能调度', support: true, content: '电信、联通、移动' }, { type: '超融合', support: false }, { type: '自动容灾', support: false }, { type: 'API', support: false }, { type: '报警检测', support: false }, { type: '短信通知', support: false }, { type: '邮件通知', support: true }, { type: '技术支持', support: false }],
        price: ['免费']
      }, {
        icon: 'enterprise',
        title: '标准版',
        desc: ['适合具有一定访问规模的企业网站，', '例如企业门户、教育、娱乐等'],
        feature: [{ type: '接入 CDN 服务商', support: true, content: '3 家' }, { type: '智能调度', support: true, content: '运营商+省份' }, { type: '超融合', support: true }, { type: '自动容灾', support: false }, { type: 'API', support: false }, { type: '报警检测', support: false }, { type: '短信通知', support: false }, { type: '邮件通知', support: true }, { type: '技术支持', support: true, content: '7*24 / QQ' }],
        price: ['99 元/月', '999 元/年']
      }, {
        icon: 'ultimate',
        title: '企业版',
        desc: ['适合中、大型企业，例如电商、视频、', '游戏、金融、跨国企业网站等'],
        feature: [{ type: '接入 CDN 服务商', support: true, content: '不限' }, { type: '智能调度', support: true, content: '运营商+省份+海外' }, { type: '超融合', support: true }, { type: '自动容灾', support: true }, { type: 'API', support: true }, { type: '报警检测', support: true }, { type: '短信通知', support: true }, { type: '邮件通知', support: true }, { type: '技术支持', support: true, content: '7*24 / QQ' }],
        price: ['599 元/月', '5999 元/年']
      }]
    };
  },

  computed: {
    delStyle: function delStyle() {
      return {
        textDecoration: 'line-through',
        color: '#b8b8b8'
      };
    }
  },
  components: { Layout: __WEBPACK_IMPORTED_MODULE_0__components_layout___default.a }
});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/beian.d0289dc.png";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(53),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb931e80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(30)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(51),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-892e569c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55dc1061",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(47),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50bf916c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('div', {
    staticClass: "illustration-bg"
  })]), _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("轻松融合多家 CDN 服务")]), _c('p', [_vm._v("杭州点智连科技有限公司，可按任意比例配置调度各 CDN 厂商流量")]), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "http://console.oncdp.com/#/login",
      "target": "_blank"
    }
  }, [_vm._v("立即体验")])])])
}]}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whatis"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("CDP 是什么？")]), _c('p', [_vm._v("CDP （Content Distribution Platform）即内容分配平台，可服务于接入多家 CDN 厂商的用户，实现了按比例灵活调配各 CDN 厂商在不同地区不同运营商中的流量带宽；并能自动收集、监测各 CDN 厂商的节点信息，相互融合，在让域名享受全网都有本地节点覆盖的同时，自动剔除故障节点，保障业务的正常服务。")])])])
}]}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("便捷的使用方式")]), _c('ul', [_c('li', [_vm._v("灵活的调度比例配置")]), _c('li', [_vm._v("部署秒级生效")]), _c('li', [_vm._v("多域名统一维护、管理")]), _c('li', [_vm._v("服务状况一目了然")])])])])
}]}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('template', {
    slot: "page"
  }, [_c('Banner'), _c('Features'), _c('Usage'), _c('Functions'), _c('WhatIs')], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', {
    attrs: {
      "header-bgc": true
    }
  }, [_c('template', {
    slot: "page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "price"
  }, _vm._l((_vm.priceData), function(price) {
    return _c('div', {
      staticClass: "price-item",
      class: price.icon
    }, [_c('div', {
      staticClass: "price-header"
    }, [_c('h3', [_vm._v(_vm._s(price.title))]), _vm._l((price.desc), function(desc) {
      return _c('p', [_vm._v(_vm._s(desc))])
    })], 2), _c('div', {
      staticClass: "price-body"
    }, [_c('ul', _vm._l((price.feature), function(feature) {
      return _c('li', [_c('span', {
        style: (feature.support || _vm.delStyle)
      }, [_vm._v(_vm._s(feature.type))]), (feature.content) ? _c('span', [_vm._v("（" + _vm._s(feature.content) + "）")]) : _vm._e()])
    }), 0), _c('p', {
      staticClass: "cost"
    }, _vm._l((price.price), function(price) {
      return _c('span', [_vm._v(_vm._s(price))])
    }), 0)]), _c('div', {
      staticClass: "price-footer"
    }, [_c('a', {
      attrs: {
        "href": "http://console.oncdp.com/#/login",
        "target": "_blank"
      }
    }, [_vm._v("立即购买")])])])
  }), 0)])])], 2)
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', {
    attrs: {
      "header-bgc": true
    }
  }, [_c('template', {
    slot: "page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("关于我们")]), _c('p', [_vm._v("CDP 融合了市面上各家 CDN 厂商，致力于打造新一代的智能融合云服务平台，为企业提供更加快速、安全、稳定的域名调度解决方案，\n帮助企业统一调配管理各 CDN 厂商的服务，做到让企业更加省心、放心")]), _c('h2', [_vm._v("我们的优势")]), _c('p', [_vm._v("融合各热门 CDN 厂商")]), _c('p', [_vm._v("国内唯一一家可按任意比例配置调度各 CDN 厂商间流量的平台")]), _c('p', [_vm._v("灵活调度，实现域名的所有访问地区都有本地节点覆盖")]), _c('p', [_vm._v("问题节点智能切换，保证域名正常运行")]), _c('p', [_vm._v("多维度告警通知，实时掌握网站动态")]), _c('h2', [_vm._v("联系我们")]), _c('p', [_vm._v("公司地址：杭州市西湖区文一西路522号9幢1单元602室")]), _c('p', [_vm._v("邮箱：sales@oncdp.com")])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('LayoutHeader', {
    attrs: {
      "header-bgc": _vm.headerBgc
    }
  }), _c('div', {
    staticClass: "layout-body"
  }, [_vm._t("page")], 2), _c('LayoutFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  })]), _c('div', {
    staticClass: "navs"
  }, [_c('router-link', {
    class: {
      active: _vm.$route.name === 'home'
    },
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("首页")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#feature'
      }
    }
  }, [_vm._v("产品特性")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'home',
        hash: '#function'
      }
    }
  }, [_vm._v("功能组件")]), _c('router-link', {
    class: {
      active: _vm.$route.name === 'price'
    },
    attrs: {
      "to": {
        name: 'price'
      }
    }
  }, [_vm._v("价格")]), _c('a', {
    attrs: {
      "href": "https://help.upyun.com/knowledge-base/cdp-product/",
      "target": "_blank"
    }
  }, [_vm._v("帮助中心")]), _c('router-link', {
    class: {
      active: _vm.$route.name === 'contact'
    },
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("联系我们")])], 1), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langing"
  }, [_c('a', {
    attrs: {
      "href": "http://console.oncdp.com/#/login",
      "target": "_blank"
    }
  }, [_vm._v("登录")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "functions",
    attrs: {
      "id": "function"
    }
  }, [_c('h2', [_vm._v("多样化的功能支持")]), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.functionData), function(func) {
    return _c('div', {
      staticClass: "function-item"
    }, [_c('div', {
      staticClass: "function-logo",
      class: func.logo
    }), _c('div', {
      staticClass: "function-header"
    }, [_vm._v(_vm._s(func.header))]), _c('p', [_vm._v(_vm._s(func.content))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('dl', [_c('dt', [_vm._v("产品服务")]), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/price"
    }
  }, [_vm._v("套餐选购")])], 1)]), _c('dl', [_c('dt', [_vm._v("关于我们")]), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("产品介绍")])], 1), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("商务合作")])], 1), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("产品优势")])], 1)]), _vm._m(0)]), _c('div', {
    staticClass: "icp"
  }, [_vm._v("© 2019 杭州点智连科技有限公司 | "), _c('a', {
    attrs: {
      "href": _vm.icpHref,
      "target": "_blank"
    }
  }, [_c('span', {
    attrs: {
      "id": "isp"
    }
  }, [_vm._v(_vm._s(_vm.icpText) + " | ")])]), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("联系我们")]), _c('dd', [_vm._v("邮箱：sales@oncdp.com")]), _c('dd', [_vm._v("地址：杭州市西湖区文一西路522号"), _c('br'), _vm._v("9幢1单元602室")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602008546",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px",
      "margin-right": "3px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("浙公网安备 33010602008546 号")])
}]}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features",
    attrs: {
      "id": "feature"
    }
  }, [_c('h2', [_vm._v("强大的产品特性")]), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.featureData), function(feature) {
    return _c('div', {
      staticClass: "feature-item"
    }, [_c('div', {
      staticClass: "function-logo",
      class: feature.logo
    }), _c('div', {
      staticClass: "feature-header"
    }, [_vm._v(_vm._s(feature.header))]), _c('p', [_vm._v(_vm._s(feature.content))])])
  }), 0)])
},staticRenderFns: []}

/***/ })
],[11]);


// WEBPACK FOOTER //
// static/js/app.88b6ba0c87eb589b8048.js